import { Play, Pause, ShieldCheck, MoreHorizontal, Coins } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";
import { fmtTime, fmtNumber } from "@/lib/format";

export default function TrackRow({ track, list, index }) {
  const p = usePlayer();
  const isCurrent = p?.current?.id === track.id;
  const isPlaying = isCurrent && p?.playing;

  return (
    <div
      data-testid={`track-row-${track.id}`}
      className={`group grid grid-cols-12 gap-3 items-center px-3 md:px-4 py-3 rounded-xl transition-colors ${
        isCurrent ? "bg-coral/5" : "hover:bg-cream-deep/40"
      }`}
    >
      <div className="col-span-1 text-xs font-mono text-ink-mid hidden sm:flex items-center justify-center w-7">
        <span className="group-hover:hidden">{String(index + 1).padStart(2, "0")}</span>
        <button
          data-testid={`track-play-${track.id}`}
          onClick={() => p.playTrack(track, list)}
          className="hidden group-hover:inline-flex w-7 h-7 rounded-full bg-coral text-cream items-center justify-center"
        >
          {isPlaying ? <Pause className="w-3.5 h-3.5" fill="currentColor" /> : <Play className="w-3.5 h-3.5 translate-x-0.5" fill="currentColor" />}
        </button>
      </div>
      <div className="col-span-7 sm:col-span-5 flex items-center gap-3 min-w-0">
        <button data-testid={`track-cover-${track.id}`} onClick={() => p.playTrack(track, list)} className="relative shrink-0">
          <img src={track.cover} alt="" className="w-11 h-11 rounded-md object-cover" />
          <span className="absolute inset-0 rounded-md bg-ink/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
            {isPlaying ? <Pause className="w-4 h-4 text-cream" fill="currentColor" /> : <Play className="w-4 h-4 text-cream translate-x-0.5" fill="currentColor" />}
          </span>
        </button>
        <div className="min-w-0">
          <p className={`text-sm truncate ${isCurrent ? "text-coral" : "text-ink"}`}>{track.title}</p>
          <p className="text-xs text-ink-mid truncate flex items-center gap-1.5">
            {track.artist_name}
            {track.promoted_horizonte && (
              <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-coral/10 text-coral text-[9px] font-mono uppercase tracking-wider rounded-full">
                Horizonte
              </span>
            )}
          </p>
        </div>
      </div>
      <div className="col-span-3 sm:col-span-3 hidden sm:flex items-center gap-1.5 text-xs text-ink-mid">
        <ShieldCheck className="w-3 h-3 text-coral" />
        {track.genre}
      </div>
      <div className="col-span-2 sm:col-span-1 text-right text-xs font-mono text-ink-mid">
        {fmtNumber(track.plays)}
      </div>
      <div className="col-span-2 sm:col-span-1 text-right text-xs text-coral">
        ${track.tips_total.toFixed(0)}
      </div>
      <div className="col-span-1 hidden sm:flex justify-end gap-1">
        <button className="w-8 h-8 rounded-full hover:bg-coral/10 text-ink-mid hover:text-coral transition flex items-center justify-center" title="Apoyar">
          <Coins className="w-3.5 h-3.5" />
        </button>
        <button className="w-8 h-8 rounded-full hover:bg-cream-deep/60 transition flex items-center justify-center text-ink-mid">
          <MoreHorizontal className="w-4 h-4" />
        </button>
      </div>
      <div className="col-span-1 sm:hidden text-right text-xs text-ink-mid font-mono">{fmtTime(track.duration_sec)}</div>
    </div>
  );
}
